export enum UIMenuItemAvailabilityStatus {
  available = 'available',
  notToday = 'notToday',
  nevermore = 'nevermore',
  hidden = 'hidden',
}

export enum UIMenuItemType {
  dish = 'dish',
  option = 'option',
}
